"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFramePromotionDetailItem = instanceOfFramePromotionDetailItem;
exports.FramePromotionDetailItemFromJSON = FramePromotionDetailItemFromJSON;
exports.FramePromotionDetailItemFromJSONTyped = FramePromotionDetailItemFromJSONTyped;
exports.FramePromotionDetailItemToJSON = FramePromotionDetailItemToJSON;
exports.FramePromotionDetailItemToJSONTyped = FramePromotionDetailItemToJSONTyped;
/**
 * Check if a given object implements the FramePromotionDetailItem interface.
 */
function instanceOfFramePromotionDetailItem(value) {
    return true;
}
function FramePromotionDetailItemFromJSON(json) {
    return FramePromotionDetailItemFromJSONTyped(json, false);
}
function FramePromotionDetailItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'frameNo': json['frameNo'] == null ? undefined : json['frameNo'],
        'qty': json['qty'] == null ? undefined : json['qty'],
    };
}
function FramePromotionDetailItemToJSON(json) {
    return FramePromotionDetailItemToJSONTyped(json, false);
}
function FramePromotionDetailItemToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'frameNo': value['frameNo'],
        'qty': value['qty'],
    };
}
